import { subDays } from 'date-fns';
import { format } from 'date-fns/format';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import reducer from './reducer';

import RouteChildViewer from '../../components/Layout/RouteChildViewer';
import { DEFAULT_PAGE_NO } from '../../config/constants/pagination';
import { useInjectReducer } from '../../utils/injectReducer';
import { useInjectSaga } from '../../utils/injectSaga';
import * as actions from './actions';
import saga from './saga';
import * as selectors from './selectors';

import {
  ITEM_BREAKDOWN_TABS,
  OOS_TABLE_TYPE,
  OOS_TABS,
} from '../../config/constants/analytics';
import {
  ANALYTICS_MODULES,
  TIME_PERIOD_LIST,
} from '../../config/constants/analytics-v2';
import { isEmpty } from '../../utils';
import { makeSelectCurrentUser } from '../App/selectors';
import { KaiFab } from './components';
import Filters from './Filters';
import Module from './Module';
import { CITY_LIST } from './sagaMap';

const NativeAnalytics = ({
  selectedAnalyticsProvider,
  analyticsStartDate,
  analyticsEndDate,
  selectedTimePeriod,
  getAnalyticsData,
  getOrdersData,
  paginationObj,
  handleUpdatePagination,
  getSummary,
  getStatus,
  isFirstTimeLoaded,
  selectedBusiness,
  selectedBranches,
  selectedBrands,
  resetAnalyticsData,
  getItemBreakdownData,
  isTimePeriodFilterStatusChanged,
  selectedChannel,
  getBusyModeAnalyticsData,
  getBusyModeLogData,
  getPaymentMethodData,
  handleGetList,
  analyticsStartTime,
  analyticsEndTime,
  getPromoSummary,
  getPromoAnalytics,
  updateField,
  getCities,
  selectedTab,
}) => {
  useInjectReducer({ key: 'nativeAnalytics', reducer });
  useInjectSaga({ key: 'nativeAnalytics', saga });

  // USE STATES
  const [isResetFilterApplied, setIsResetFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [oosDefaultTab, setOosDefaultTab] = useState(OOS_TABS[0]);
  const [oosDefaultTableType, setOosDefaultTableType] = useState(
    OOS_TABLE_TYPE.ITEMS.title,
  );
  const { pageNo, pageSize } = paginationObj || {};

  useEffect(() => {
    getStatus();
    getCities({ ...CITY_LIST });

    return () => {
      updateField({
        analyticsProviders: [],
        branches: [],
        brands: [],
        previousOrderReports: [],
        selectedAnalyticsTypeOOS: OOS_TABS[0],
        selectedBranch: [],
        savedNonCashBranchSelection: [],
        selectedBrand: [],
        selectedBusiness: null,
        selectedDateRange: {
          start: subDays(new Date(), 6),
          end: new Date(),
        },
        selectedEntityTypeOOS: OOS_TABLE_TYPE.ITEMS,
        selectedMenuReportType: ITEM_BREAKDOWN_TABS[0],
        selectedProvider: [],
        selectedOwnChannel: null,
        selectedTab: ANALYTICS_MODULES.OVERVIEW,
        selectedTimePeriod: TIME_PERIOD_LIST[0],
      });
    };
  }, []);

  // USE EFFECTS
  useEffect(() => {
    if (isFirstTimeLoaded) {
      getAllData();
    }
  }, [isFirstTimeLoaded]);

  useEffect(() => {
    if (isResetFilterApplied) {
      getAllData();
    }
  }, [isResetFilterApplied]);

  // HANDLERS
  // =======
  const setToFirstPage = () => {
    if (pageNo !== DEFAULT_PAGE_NO)
      handleUpdatePagination(DEFAULT_PAGE_NO, pageSize);
  };

  const handleAnalyticParamData = () => {
    if (
      isEmpty(selectedBusiness) ||
      (isEmpty(selectedBranches) && isEmpty(selectedBrands))
    ) {
      return null;
    }

    const startDate = format(analyticsStartDate, 'yyyy-MM-dd');
    const endDate = format(analyticsEndDate, 'yyyy-MM-dd');

    const selectedBrandIds = !isEmpty(selectedBrands)
      ? selectedBrands.map(b => b.id).join(',')
      : '';

    const selectedBranchIds = !isEmpty(selectedBranches)
      ? selectedBranches.map(b => b.id).join(',')
      : '';

    const providerIds = !isEmpty(selectedAnalyticsProvider)
      ? selectedAnalyticsProvider.map(p => p.id).join(',')
      : [];

    const channelIds = !isEmpty(selectedChannel)
      ? selectedChannel.map(c => c.id).join(',')
      : [];

    const params = {
      provider_id: providerIds,
      branch_id: selectedBranchIds,
      brand_id: selectedBrandIds,
      period_start: startDate,
      period_hour_start: analyticsStartTime,
      period_hour_end: analyticsEndTime,
      period: selectedTimePeriod && selectedTimePeriod.id,
      order_source: channelIds,
    };

    if (startDate !== endDate) {
      params.period_end = endDate;
    }

    return { ...params };
  };

  const makeOrderDataRequest = params => {
    const orderParams = { ...params, page_no: pageNo, page_size: pageSize };
    getOrdersData(orderParams);
  };

  const getAllData = filterObj => {
    const { isMoreThan30Days } = filterObj || {};
    const params = handleAnalyticParamData();
    const hasParams = params && Object.keys(params).length > 0;

    if (hasParams) {
      // getAnalyticsData(params);
      // getSummary(params);

      if (!isMoreThan30Days) {
        makeOrderDataRequest(params);
      }

      // const itemBreakdownParam = {
      //   ...params,
      //   activeTab: selectedMenuReportType.key,
      // };
      // getItemBreakdownData(itemBreakdownParam);
      // getBusyModeAnalyticsData(params);
      // getBusyModeLogData(params);

      // getPaymentMethodData(params);

      // handleGetList({
      //   url: NATIVE_ANALYTICS_SAGA.OOS_REPORT_ITEM.GET,
      //   params,
      //   reducerKey: NATIVE_ANALYTICS_SAGA.OOS_REPORT_ITEM.KEY,
      // });
      // getPromoSummary({
      //   ...PROMO_SUMMARY,
      //   params: {
      //     ...params,
      //     business_id: selectedBusiness.id,
      //   },
      //   callbackFn: resp => {
      //     updateField({
      //       promoSummary: resp || {},
      //     });
      //   },
      // });
      // getPromoAnalytics({
      //   ...PROMO_LIST,
      //   params: {
      //     ...params,
      //     business_id: selectedBusiness.id,
      //   },
      //   callbackFn: resp => {
      //     updateField({
      //       promoAnalytics: resp || [],
      //     });
      //   },
      // });
    } else {
      resetAnalyticsData();
    }
  };
  const handleAnalyticsFilterApply = (e, filterObj) => {
    getAllData(filterObj);
    setIsResetFilterApplied(false);
    setToFirstPage();
    setOosDefaultTab(OOS_TABS[0]);
    setOosDefaultTableType(OOS_TABLE_TYPE.ITEMS.title);
  };
  const handleAnalyticsFilterReset = () => {
    setIsResetFilterApplied(true);
    setToFirstPage();
  };

  return (
    <RouteChildViewer headerTitle="Analytics">
      <Helmet>
        <title>Analytics</title>
        <meta name="title" content="Analytics" />
      </Helmet>
      <div className="flex flex-col gap-y-4">
        <Filters />
        <Module />
      </div>
      <KaiFab />
    </RouteChildViewer>
  );
};

NativeAnalytics.propTypes = {
  selectedAnalyticsProvider: PropTypes.any,
  analyticsStartDate: PropTypes.any,
  analyticsEndDate: PropTypes.any,
  selectedTimePeriod: PropTypes.object,
  paginationObj: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  getAnalyticsData: PropTypes.func,
  getOrdersData: PropTypes.func,
  getSummary: PropTypes.func,
  getStatus: PropTypes.func,
  isFirstTimeLoaded: PropTypes.bool,
  selectedBusiness: PropTypes.object,
  selectedBranches: PropTypes.array,
  selectedBrands: PropTypes.array,
  resetAnalyticsData: PropTypes.func,
  getItemBreakdownData: PropTypes.func,
  isTimePeriodFilterStatusChanged: PropTypes.bool,
  selectedChannel: PropTypes.any,
  getBusyModeAnalyticsData: PropTypes.func,
  getBusyModeLogData: PropTypes.func,
  getPaymentMethodData: PropTypes.func,
  handleGetList: PropTypes.func,
  analyticsStartTime: PropTypes.any,
  analyticsEndTime: PropTypes.any,
  getPromoAnalytics: PropTypes.func,
  getPromoSummary: PropTypes.func,
  updateField: PropTypes.func,
  getCities: PropTypes.func,
  selectedTab: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  analyticsProviders: selectors.makeSelectAnalyticsProviders(),
  selectedAnalyticsProvider: selectors.makeSelectAnalyticsSelectedProvider(),
  analyticsStartDate: selectors.makeSelectAnalyticsStartDate(),
  analyticsEndDate: selectors.makeSelectAnalyticsEndDate(),
  selectedTimePeriod: selectors.makeSelectSelectedTimePeriod(),
  paginationObj: selectors.makeSelectPaginationObj(),
  isFirstTimeLoaded: selectors.makeSelectIsFirstTimeLoaded(),
  selectedBusiness: selectors.makeSelectAnalyticsSelectedBusiness(),
  selectedBranches: selectors.makeSelectAnalyticsSelectedBranch(),
  selectedBrands: selectors.makeSelectAnalyticsSelectedBrand(),
  currentUser: makeSelectCurrentUser(),
  isTimePeriodFilterStatusChanged:
    selectors.makeSelectSelectedTimePeriodStatus(),
  selectedChannel: selectors.makeSelectSelectedChannel(),
  analyticsStartTime: selectors.makeSelectProperty('analyticsStartTime'),
  analyticsEndTime: selectors.makeSelectProperty('analyticsEndTime'),
  selectedTab: selectors.makeSelectProperty('selectedTab'),
});

function mapDispatchToProps(dispatch) {
  return {
    getAnalyticsData: params => dispatch(actions.loadAnalyticsData(params)),
    getOrdersData: params => dispatch(actions.loadOrdersData(params)),
    handleUpdatePagination: (page, size) =>
      dispatch(actions.updatePagination(page, size)),
    getSummary: params => dispatch(actions.loadSummary(params)),
    getStatus: () => dispatch(actions.loadStatus()),
    resetAnalyticsData: () => dispatch(actions.resetAnalyticsData()),
    getItemBreakdownData: params =>
      dispatch(actions.loadItemBreakdownData(params)),
    getBusyModeAnalyticsData: params =>
      dispatch(actions.loadBusyModeAnalyticsData(params)),
    getBusyModeLogData: params => dispatch(actions.loadBusyModeLogData(params)),
    getPaymentMethodData: params =>
      dispatch(actions.loadPaymentMethodData(params)),
    handleGetList: params => dispatch(actions.getList(params)),
    getPromoSummary: params => dispatch(actions.getEntity(params)),
    getPromoAnalytics: params => dispatch(actions.loadList(params)),
    updateField: params => dispatch(actions.updateEntity(params)),
    getCities: params => dispatch(actions.loadList(params)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(NativeAnalytics);
